import React, {Component, PropTypes} from 'react';
import {Navbar, NavItem, Nav} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';

export default class Header extends Component {
  static propTypes = {
    children: PropTypes.element,
    logoutRequested: PropTypes.func.isRequired
  };

  handleLogout = () => {
    this.props.logoutRequested();
  };

  render() {
    return (
      <div>
        <Navbar inverse collapseOnSelect>
          <Navbar.Header>
            <Navbar.Brand>Admin panel</Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav>
              <LinkContainer to="/admin/users">
                <NavItem>Users</NavItem>
              </LinkContainer>
              <LinkContainer to="/admin/candidates">
                <NavItem>Candidates</NavItem>
              </LinkContainer>
              <LinkContainer to="/admin/recruiters">
                <NavItem>Recruiters</NavItem>
              </LinkContainer>
              <LinkContainer to="/admin/vacancies">
                <NavItem>Vacancies</NavItem>
              </LinkContainer>
              <LinkContainer to="/admin/matches">
                <NavItem>Matches</NavItem>
              </LinkContainer>
            </Nav>
            <Nav pullRight>
              <NavItem eventKey={2} onClick={this.handleLogout}>
                Logout
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.jsx